require('./_set-species')('Array');


//////////////////
// WEBPACK FOOTER
// D:/Work/Development/vsts_build/_work/2/s/web/node_modules/core-js/modules/es6.array.species.js
// module id = Umeq
// module chunks = 2